import LoadingComponent from './SectionLoading/Loading';
import PageLoadingComponent from './PageLoading/PageLoading';
import CustomLoadingComponent from './CustomLoading/CustomLoading';

export const Loading = LoadingComponent;
export const PageLoading = PageLoadingComponent;
export const CustomLoading = CustomLoadingComponent;
